module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ke-Ld.7e421d56.png";